module.exports = __webpack_public_path__ + "static/media/bi-mdpp-hanmi-manager.9b2b477e.svg";